import appendForm from '../../features/companies/companies_channels_actions';

window.Bizneo.companies_channels_controller = {
  channel_form(channel, html) {
    appendForm(channel, html);
  },
};
